// Signed in with no company yet: name it, and become its owner (pending approval, design Q3).
import { useState } from "react";
import { AuthFrame } from "../App";
import { api } from "../lib/api";
import { signOut } from "../lib/auth";
import type { Me } from "../lib/types";
import { inputCls } from "../components/bits";
import { Button, ErrorNote } from "../components/ui";
import { SIGNUP_COMPANY } from "./Signup";

export default function Onboarding({ me, onDone }: { me: Me; onDone: () => Promise<void> }) {
  const [name, setName] = useState(() => sessionStorage.getItem(SIGNUP_COMPANY) ?? "");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  return (
    <AuthFrame>
      <h1 className="text-2xl font-bold font-display">Set up your company</h1>
      <p className="text-sm text-muted mt-1">Signed in as {me.email}</p>
      {me.federated && (
        <div className="mt-5 text-left">
          <ErrorNote>Your company's single sign-on isn't linked to an eSignIt account for you. Ask your company admin to invite you.</ErrorNote>
        </div>
      )}
      {err && (
        <div className="mt-5 text-left">
          <ErrorNote>{err}</ErrorNote>
        </div>
      )}
      {!me.federated && (
        <form
          className="mt-6 text-left space-y-3"
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true);
            setErr(null);
            try {
              await api("/companies", { body: { name } });
              sessionStorage.removeItem(SIGNUP_COMPANY);
              await onDone();
            } catch (x) {
              setErr((x as Error).message);
              setBusy(false);
            }
          }}
        >
          <label className="block text-sm font-medium text-ink-2" htmlFor="co">
            Company name
          </label>
          <input id="co" required value={name} onChange={(e) => setName(e.target.value)} className={inputCls} />
          <Button variant="primary" type="submit" className="w-full h-11" busy={busy}>
            Create company
          </Button>
          <p className="text-xs text-muted">You'll be its owner. Joining a colleague's company instead? Ask them to invite {me.email}.</p>
        </form>
      )}
      <button onClick={() => signOut()} className="text-sm text-muted hover:text-ink mt-6">
        Sign out
      </button>
    </AuthFrame>
  );
}
